import { AudioCache } from '@mote/helpers/hooks/recorder/AudioCache'
import type { FileRepository } from '../file'

export class SoundPlayer {
  audioCache: AudioCache = new AudioCache()
  fileRepository: FileRepository

  constructor(fileRepository: FileRepository) {
    this.fileRepository = fileRepository
  }

  playCancel() {
    this.fileRepository
      .getCancelRecordingSound()
      .then(url => {
        return this.#defer(url)
      })
      .catch(() => {
        /*NOOP*/
      })
  }

  playFinish() {
    this.fileRepository
      .getFinishRecordingSound()
      .then(url => {
        return this.#defer(url)
      })
      .catch(() => {
        /*NOOP*/
      })
  }

  #defer(url: string) {
    return new Promise(resolve =>
      requestAnimationFrame(() => resolve(this.audioCache.get(url).play()))
    )
  }
}
